import { axiosInstance } from '../../axios';
import {
  SystemPromptSetting,
  UpdateSystemPromptPayload,
} from './setting.interface';

export function fetchSystemPrompt() {
  return axiosInstance
    .get<SystemPromptSetting>('/api/admin/setting/system-prompt')
    .then((response) => response.data);
}

export function updateSystemPrompt(payload: UpdateSystemPromptPayload) {
  return axiosInstance
    .patch<SystemPromptSetting>('/api/admin/setting/system-prompt', payload)
    .then((response) => response.data);
}
